import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// --- Performance: in-flight de-duplication + short-TTL cache for read-mostly GETs ---
// Default TTLs for stable, frequently-read endpoints. Any mutation busts the whole cache.
const DEFAULT_TTL = [
  ["/auth/me", 60000],
  ["/dashboard", 60000],
  ["/pm-brain/hq", 30000],
  ["/content", 300000],
];
const ttlFor = (url, config) => {
  if (config && typeof config.cache === "number") return config.cache;
  const hit = DEFAULT_TTL.find(([p]) => url === p || url.startsWith(p + "?"));
  return hit ? hit[1] : 0;
};

const inflight = new Map();
const cache = new Map();
const _get = api.get.bind(api);

api.get = (url, config) => {
  const key = url + (config && config.params ? JSON.stringify(config.params) : "");
  const now = Date.now();
  const cached = cache.get(key);
  if (cached && cached.exp > now) return Promise.resolve(cached.res);
  if (inflight.has(key)) return inflight.get(key);
  const ttl = ttlFor(url, config);
  const p = _get(url, config)
    .then((res) => { inflight.delete(key); if (ttl > 0) cache.set(key, { res, exp: Date.now() + ttl }); return res; })
    .catch((e) => { inflight.delete(key); throw e; });
  inflight.set(key, p);
  return p;
};

// Any write invalidates the read cache so reloads always get fresh data (no staleness).
["post", "put", "patch", "delete"].forEach((m) => {
  const orig = api[m].bind(api);
  api[m] = (...args) => { cache.clear(); return orig(...args); };
});

export const clearApiCache = () => cache.clear();
export default api;
